import React, { useEffect, useState } from "react";
import Select from 'react-select';
import archiveArticlesService from "../../services/api/archive-articles-service";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Alert,
  Spinner,
  Container,
  Row,
  Col,
} from "reactstrap";

const ArchiveArticles = () => {
  const [projectOptions, setProjectOptions] = useState([]);
  const [project, setProject] = useState(null);
  const [input, setInput] = useState("");
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  useEffect(() => {
    (async () => {
      const response = await archiveArticlesService.getProjects();
      if (response.status) {
        setProjectOptions(response.data.map((p) => ({ value: p.id, label: p.name })));
      } else {
        setAlert({ show: true, type: "danger", message: "Unable to load archive projects." });
      }
    })();
  }, []);

  const resetResult = () => {
    setArticle(null);
    setAlert({ show: false, type: "", message: "" });
  }

  const findArticle = async (e) => {
    e.preventDefault();
    resetResult();
    if (!project || !input.trim()) {
      setAlert({ show: true, type: "danger", message: "Select a project and enter a GUID, slug or URL." });
      return;
    }
    setLoading(true);
    const response = await archiveArticlesService.previewArticle(project.value, input.trim());
    setLoading(false);
    if (response.status) {
      setArticle(response.data);
    } else {
      setAlert({ show: true, type: "danger", message: response.error && response.error.errorCode === 4042 ? "Article not found." : "Unable to find the article, please try again." });
    }
  }

  const deleteArticle = async () => {
    if (!window.confirm(`Permanently delete "${article.title || article.key}" from ${project.label}? This cannot be undone.`)) return;
    setLoading(true);
    const response = await archiveArticlesService.deleteArticle(project.value, input.trim());
    setLoading(false);
    if (response.status) {
      setArticle(null);
      setInput("");
      setAlert(response.data.turbo_cleared
        ? { show: true, type: "success", message: "Article deleted and page cache clear queued." }
        : { show: true, type: "warning", message: "Article deleted, but the page cache could not be cleared. It may show for up to 7 days." });
    } else {
      setAlert({ show: true, type: "danger", message: "Unable to delete the article, please try again." });
    }
  }

  return (
    <div className="content">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <Card className="card-signup text-center">
              <CardHeader>
                <CardTitle tag="h4">Delete Archive Article</CardTitle>
              </CardHeader>
              <CardBody>
                <form className="form-horizontal" onSubmit={findArticle}>
                  <Row>
                    <Label className="bold" sm="2">Select Project <span className="text-danger"> * </span></Label>
                    <Col sm="7">
                      <FormGroup>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="project"
                          value={project}
                          onChange={(value) => { setProject(value); resetResult(); }}
                          options={projectOptions}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Label className="bold" sm="2">GUID, slug or URL <span className="text-danger"> * </span></Label>
                    <Col sm="7">
                      <FormGroup>
                        <Input
                          name="input"
                          type="text"
                          value={input}
                          onChange={(e) => { setInput(e.target.value); resetResult(); }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button className="btn-round" color="info" type="submit" disabled={loading}>Find</Button>
                  {loading ? <Spinner animation="border" role="status" /> : null}
                </form>

                {article ?
                  <div className="text-left mt-4">
                    <p><b>Title:</b> {article.title || "-"}</p>
                    <p><b>URL:</b> {article.url ? <a href={article.url} target="_blank" rel="noopener noreferrer">{article.url}</a> : "-"}</p>
                    <p><b>Key:</b> {article.key}</p>
                    <Button className="btn-round" color="danger" onClick={deleteArticle} disabled={loading}>Delete permanently</Button>
                  </div>
                  : null}

                {alert.show ? <Alert color={alert.type} className="mt-3">{alert.message}</Alert> : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ArchiveArticles;
